import {  Injectable, NgZone } from '@angular/core';
import { Subject, Observable, ReplaySubject, BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { ActivatedRoute, ActivationStart, NavigationEnd, Router, RoutesRecognized } from '@angular/router';
import { BreadcrumbModel, QueovalParam, BreadDik, PageInfo, MainModel, MainShortcut, MainActionData } from '../models/global/class.global';
import { splitRoute } from '../utilities/utilities.function';
import { CoreService } from './core.service';
import { HttpService } from './dataAccess.service';
//import { CoreService, HttpService } from '../services';

@Injectable({
  providedIn: 'root'
})


export class BreadcrumbService {

  private _breadcrumb: Array<BreadcrumbModel> = new Array<BreadcrumbModel>();                   // breadcrumb main element
  public breadcrumb$: Subject<Array<BreadcrumbModel>> = new Subject<Array<BreadcrumbModel>>();  // breadcrumb 'Subject' wrap for the main element (it make the main element an Observable and an Observer)  

  public raccourciData: MainActionData;
  public codeBO: string = '';
  public idDonnee: string = '';

  constructor(
    private router: Router,
    private activeRoute: ActivatedRoute,
    private indParam: CoreService,
    protected data: HttpService,
    protected zone: NgZone,
  ) { 
  }

  public ParamData: any = null;
  public emmiter: Subject<any> = new ReplaySubject<any>(1);
  // [used in LIB-COMPONENTS]:  src/agenda/agenda.queoval.service.ts
  get Breadcrumb(): Array<BreadcrumbModel> { return this._breadcrumb; }

  // [used in QUEOVAL]: /src/app/views/agenda/action-co/agenda.action-co.component.ts(17,41)
  //                    /src/app/views/agenda/agenda-reservation-stagiaire/agenda.reservation-stagiaire.component.ts(19,68)
  //                    /src/app/views/agenda/conges/agenda.conges.component.ts(19,68):
  //                    /src/app/views/agenda/rendez-vous-formateur/agenda.rendez-vous-formateur.component.ts(20,68):
  //                    /src/app/views/agenda/rendez-vous/agenda.rendez-vous.component.ts(20,68):
  //                    /src/app/views/agenda/reservation-formateur/agenda.reservation-formateur.component.ts(19,68):
  //                    /src/app/views/agenda/reservation/agenda.reservation.component.ts(20,68):
  //                    /src/app/views/agenda/taches/agenda.taches.component.ts(19,68):
  //                    /src/app/views/agenda/zoom/agenda.zoom.component.ts(31,18):
  //                    /src/app/views/facturation/bo-facturation/bo-facturation.component.ts(136, 68):
  //                    /src/app/views/facturation/mode_facturation/mode-facturation.component.ts(86,68):
  //                    /src/app/views/statistique/elearning/detailApprenant/detailApprenant.component.ts(42,68):
  //                    /src/app/views/statistique/elearning/detailCyle/detailCyle.component.ts(34,68):
  get Params(): QueovalParam {
    return this._breadcrumb.length > 0
      ? this._breadcrumb[this._breadcrumb.length - 1].data
      : new QueovalParam();
  }

  // [used only in EXTRANET]: app/layout/component/newnavigation/newnavigation.component.ts
  // [used only in QUEOVAL]:  app/app.component.ts
  getBreadcumb(): Observable<Array<BreadcrumbModel>> {
    return this.breadcrumb$.asObservable().pipe(
      map((res: Array<BreadcrumbModel>) => {
        return res;
      })
    );
  }

  // [used only in EXTRANET]: app/layout/component/newnavigation/newnavigation.component.ts
  // [used only in this class]
  itemClick(index: number, item: BreadcrumbModel): string {
    // click event on breadcrumb
    this.deleteLink(index);
    const dest: string = (item.params && item.params !== '')
      ? `${item.link}?${item.params}`
      : item.link;
    return dest;
  }

  // [used only in EXTRANET]: app/layout/component/newnavigation/newnavigation.component.ts
  // [used only in QUEOVAL]: app/app.component.ts
  itemsClear(): void {
    this.reload();
  }

  // [used only in EXTRANET]: app/app.component.ts
  //                          app/layout/components/newnavigation/newnavigation.component.ts
  //                          app/webform/login.component.ts
  //itemAddinExtranet(link: string, title: string, addClick: boolean, params: QueovalParam | null = null): void {
  // GGPP only for the moment
  itemAddinExtranet(link: string, title: string, addClick: boolean, params: QueovalParam | null = null): void {
    this.call(new BreadcrumbModel('add', link, params, title, addClick));
  }
  itemAddinExtranetNew(link: string, title: string, addClick: boolean, params: QueovalParam | null = null): void {
    this.call(new BreadcrumbModel('addextranet', link, params, title, addClick));
  }

  // [used only in QUEOVAL]: app/app.component.ts
  //                         app/core/queoval.service.ts
  itemAdd2(link: string, title: string, addClick: boolean, params: QueovalParam | null = null): void {
    const brM: BreadcrumbModel = new BreadcrumbModel('add', link, params, title, addClick);
    this._breadcrumb.push(brM);
    this.breadcrumb$.next(this._breadcrumb);
  }

  // [used in QUEOVAL]: app/core/queoval.service.ts
  // [used in LIB]: src/boadmin/boadmin-base.component.ts
  //                src/bodisplay/bo.base.component
  itemAdd3(link: string, title: string, addClick: boolean, qsparams: string = ''): void {
    const brM: BreadcrumbModel = new BreadcrumbModel('add', link, null, title, addClick, qsparams);
    this._breadcrumb.push(brM);
    this.breadcrumb$.next(this._breadcrumb);
  }


  // [used in QUEOVAL]: app/core/queoval.service.ts
  changeShortcut(linkSC: string, titleSC: string, addClick: boolean, params: QueovalParam): void {
    // On remet le fil d'ariane à 0
    this.itemsClear();
    // On pousse le shorcut dans le fil d'ariane car le click mene forcement à un nouveau contexte
    this.call(new BreadcrumbModel('add', linkSC, params, titleSC, addClick));
  }

  // [used in QUEOVAL]: app/core/queoval.service.ts
  changeBlock(linkBlock: string, titleBlock: string, addClick: boolean, params: QueovalParam): void {
    // On supprime les liens dans le breadcumb et on garde le shortcut
    this.deleteLink(0);
    // On crée un nouveau breadcrumpModel avec les données du block
    this.call(new BreadcrumbModel('add', linkBlock, params, titleBlock, addClick));
  }

  // [used in QUEOVAL]: app/core/queoval.service.ts
  // [used only in this class]
  changeTreeview(blockBreadItem: BreadcrumbModel, treeBreadItemList: BreadcrumbModel[]): void {
    // On change de page donc on supprime tous les elements du fil d'ariane à part le shortcut (notre contexte)
    this.deleteLink(0);
    // on pousse le parent block item
    this.call(blockBreadItem);
    // on pousse les eventual parent treeviews
    if (treeBreadItemList.length > 0) {
      for (const treeview of treeBreadItemList) {
        this.call(treeview);
      }
    }
  }

  //#region only for AGENDA

  // [used only in EXTRANET]: app/webform/agenda/agenda-reservation/agenda-reservation.component.ts
  //                          app/webform/agenda/agenda.reservation-formateur/agenda.reservation-formateur.component.ts
  //                          app/webform/agenda/agenda.rendez-vous/agenda.rendez-vous.component.ts
  //                          app/webform/agenda/agenda.rendez-vous-formateur/agenda.rendez-vous-formateur.component.ts
  // [used only in QUEOVAL]:  app/views/agenda/reservation/agenda-reservation.component.ts
  //                          app/views/agenda/agenda-reservation-stagiaire/agenda-reservation-stagiaire.component.ts
  //                          app/views/agenda/reservation-formateur/agenda.reservation-formateur.component.ts
  //                          app/views/agenda/agenda.rendez-vous/agenda.rendez-vous.component.ts
  //                          app/views/agenda/agenda.rendez-vous-formateur/agenda.rendez-vous-formateur.component.ts
  changeContext(breadItem: BreadcrumbModel): void {
    this.switchContext(breadItem);
  }

  // [used only in EXTRANET]: app/webform/agenda/agenda-action-co/agenda-action-co.component.ts
  //                          app/webform/agenda/agenda-reservation/agenda-reservation.component.ts
  //                          app/webform/agenda/agenda.reservation-stagiaire/agenda.reservation-stagiaire.component.ts
  //                          app/webform/agenda/conges/agenda.conges.component.ts
  //                          app/webform/agenda/agenda.rendez-vous/agenda.rendez-vous.component.ts
  //                          app/webform/agenda/agenda.rendez-vous-formateur/agenda.rendez-vous-formateur.component.ts
  //                          app/webform/agenda/agenda.reservation-formateur/agenda.reservation-formateur.component.ts
  //                          app/webform/agenda/taches/agenda.taches.component.ts
  // [used only in QUEOVAL]:  app/views/agenda/agenda-action-co/agenda-action-co.component.ts
  //                          app/views/agenda/reservation/agenda-reservation.component.ts
  //                          app/views/agenda/agenda.reservation-stagiaire/agenda.reservation-stagiaire.component.ts
  //                          app/views/agenda/conges/agenda.conges.component.ts
  //                          app/views/agenda/agenda.rendez-vous/agenda.rendez-vous.component.ts
  //                          app/views/agenda/agenda.rendez-vous-formateur/agenda.rendez-vous-formateur.component.ts
  //                          app/views/agenda/reservation-formateur/agenda.reservation-formateur.component.ts
  //                          app/views/agenda/taches/agenda.taches.component.ts
  //                          app/views/agenda/zoom/agenda.zoom.component.ts
  //                          app/views/agenda/statistique/elearning/detailApprenant/detailApprenant.component.ts
  //                          app/views/agenda/statistique/elearning/detailCycle/detailCycle.component.ts
  Back(index: number = 1): void {
    this.backLink(index);
  }

  //#endregion

  // [used only in EXTRANET]: app/layout/components/newnavigation/newnavigation.component.ts
  //                          app/webform/agenda/agenda.reservation-stagiaire/agenda.reservation-stagiaire.component.ts
  //                          app/webform/agenda/agenda.component.ts
  //                          app/webform/agenda/zoom/agenda.zoom.component.ts
  // [used only in QUEOVAL]:  app/views/agenda/agenda.component.ts
  call(breadItem: BreadcrumbModel, index: number = -1,param?: any): void {
    const indice: Array<BreadDik> = breadItem.data.params.filter((element: BreadDik) => element.key === 'indice');
    switch (breadItem.mode) {
      case 'addextranet':
        this._breadcrumb.push(breadItem);
        this.breadcrumb$.next(this._breadcrumb);
        break;
      case 'add':
        this.addToBreadcrumb(breadItem, this._breadcrumb.length, param);
        break;
      case 'replaceNode':
        this.addToBreadcrumb(breadItem, index, param);
        break;
      case 'changeContext': // used by BOComponent
        this.switchContext(breadItem);
        break;
      case 'back':
        this.backLink((indice.length === 0 || !indice[0].value) ? 1 : indice[0].value);      
        break;
      case 'delete':
        this.deleteLink((indice.length === 0 || !indice[0].value) ? 0 : indice[0].value);      
        break;
      case 'reload':
        this.reload();
        break;
    }
  }

  //#region only for FACTURATION

  // [used only in QUEOVAL]:  app/views/facturation/recherche_factures/recherche_factures.component.ts
  deleteItemWhenBack(pageLink: string): void {
    let index: number = 0;   
    for (let i: number = 0; i < this._breadcrumb.length; i++) {
      if (this._breadcrumb[i].link === pageLink) {
        index = i;
        break;
      }
    }
    if (this._breadcrumb.length > index) {
      this._breadcrumb.splice(index + 1, this._breadcrumb.length - index - 1);
    }

  }

  //#endregion

  //#region Private Function

  //// push un item dans le breadcrumb
  private addToBreadcrumb(brM: BreadcrumbModel, index: number = this._breadcrumb.length, queryParams?: any): void {
    let baseRoute: string = '';

    index = index < 0 ? this._breadcrumb.length + index : index;
    this._breadcrumb.splice(index, this._breadcrumb.length - 1, brM);
    this.breadcrumb$.next(this._breadcrumb);

    if (brM.params === '' || brM.params === null || brM.params === undefined) {
      baseRoute = brM.link;
      this.router.navigate([brM.link], { queryParams }).then(() => {
      }).catch((ex: any) => {
        this.testRouteERR(ex, baseRoute);
      });
    } else {
      if (brM.params.indexOf('=') === -1) {
        baseRoute = `${brM.link}/${brM.params}`;
        this.router.navigate([`${brM.link}/${brM.params}`], { queryParams }).then(() => {
        }).catch((ex: any) => {
          this.testRouteERR(ex, baseRoute);
        });
      }
      else {
        baseRoute = brM.link;
        //  this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this.router.navigate([brM.link, splitRoute(`${brM.link}?${brM.params}`)], { skipLocationChange: true,queryParams }).then(() => {
        }).catch((ex: any) => {
          this.testRouteERR(ex, baseRoute);
        });
        //  });
      }
    }
  }

  // Redirection suite au test de l'existance de la route
  private testRouteERR(ex: any, baseRoute: string): void {
    console.error('Route not found, error:');
    console.error(ex);
    localStorage.setItem('unfoundroute', baseRoute);
    this.router.navigate(['view/notfound']);
  }

  // Permet de remplacer le model par un nouveau model apres chargement
  private switchContext(bread: BreadcrumbModel): void {   
    if (this._breadcrumb.length > 0) {
      const prm: QueovalParam = this._breadcrumb[this._breadcrumb.length - 1].data;
      if (prm) {
        prm.model = bread.data.model;
        prm.params.push(new BreadDik('isLoaded', true));
      }
    }
    this.breadcrumb$.next(this._breadcrumb);
    this.addToBreadcrumb(bread);
  }

  private backLink(index: number): void {
    let clickable: boolean = false;
    while (!clickable) {
      // (this._breadcrumb.length - 1 ) => current breadcrumb element
      // - index to check clickability of backed element
      clickable = this._breadcrumb[(this._breadcrumb.length - 1) - index].clickable || index === this._breadcrumb.length - 1;
      if (!this._breadcrumb[(this._breadcrumb.length - 1) - index].clickable) {
        index++;
      }

    }
    let originChild: string = this._breadcrumb[this._breadcrumb.length - 1].link;
    this._breadcrumb.splice(this._breadcrumb.length - index, index);
    this.breadcrumb$.next(this._breadcrumb);
    if (this._breadcrumb.length > 0) {
      // get the parameters of the last element in the _breadcrumb

      let link: string = this._breadcrumb[this._breadcrumb.length - 1].link;
      if (link.substring(0, 4) === 'http' || link.includes('aspx')) {
        if (!link.includes('?')) {
          const params: string = this._breadcrumb[this._breadcrumb.length - 1].params;
          if (params) {
            link += `?${params}`;
          }
        }
        if (!link || link === 'EMPTY') {
          this.router.navigate(['']);
        } else {
          localStorage.setItem('frameref', link);
          this.router.navigate(['/view/iframe']);
        }
      }
      else {
        let prm: QueovalParam | null = this._breadcrumb[this._breadcrumb.length - 1].data;
        if (!prm || (!prm.model && (!prm.params || prm.params.length < 1))) {

          let link: string = this._breadcrumb[this._breadcrumb.length - 1].link;
          if (!prm) {
            prm = new QueovalParam(new BreadDik('childFrom', originChild))
          }
          else if (!prm.params || prm.params.length < 1) {
            prm.params = [new BreadDik('childFrom', originChild)]
          }
          const param: any = {};

          if (link.includes('?')) {
            const splitedLink = link.split('?')

            splitedLink[1].split('&').forEach((keyValuePair: string) => {
              const objKeyValuePair: string[] = keyValuePair.split('=');
              param[objKeyValuePair[0]] = objKeyValuePair[1]
              if (prm != null) {
                prm.params.push(new BreadDik(objKeyValuePair[0], objKeyValuePair[1]));
              }
            })

            this.router.navigate([splitedLink[0], param]);
          } else {
            
            const params: string = this._breadcrumb[this._breadcrumb.length - 1].params;
            if (params) 
              link += `?${params}`;

            this.router.navigate([link], param);
          }
        }
        else {
          // -------------------- stock the link of the page we come from --------------------
          // let originChild: string = this._breadcrumb[this._breadcrumb.length - 1].link;
          const iChildFrom: number = prm.params.findIndex(e => e.key == 'childFrom')
          if (iChildFrom > -1) {
            prm.params[iChildFrom].value = originChild;
          } else {
            prm.params.push(new BreadDik('childFrom', originChild));
          }
          // ---------------------------------------------------------------------------------

          // -------------------- get the eventual previous parameter ------------------------
          const previousParams: Array<BreadDik> | null = prm.params.filter((element: BreadDik) => element.key === 'params');
          const prevPrm: any = previousParams.length === 0 || !previousParams[0].value ? {} : previousParams[0].value;

          let goTo: string = this._breadcrumb[this._breadcrumb.length - 1].link;
          // ---------- this is a specific fix for the agenda components breadcrumb management
          if (goTo.indexOf('/view/agenda/agenda') > -1 && goTo.indexOf('?') > -1) {
            this.openView(goTo);
          } else {
            // ---------------------------------------------------------------------------------
            if (goTo.includes('?')) {
              this.router.navigate([this.uniformizeUrl(goTo), prevPrm]);
            }
            else {

              let routePath: string = goTo;
              if (prevPrm && !this.isEmpty(prevPrm)) {
                routePath = `${goTo}?${prevPrm}`
              }
              else {
                const params: string = this._breadcrumb[this._breadcrumb.length - 1].params;
                if (params)
                  routePath = `${goTo}?${params}`;
              }
              
              this.openView(routePath);
            }
            // ---------------------------------------------------------------------------------
          }
        }
      }
    }
  }

  private isEmpty(obj: object): boolean {
    for (var key in obj) {
      if (obj.hasOwnProperty(key))
        return false;
    }
    return true;
  }

  private openView(routePath: string): void {
    this.indParam.CurrentUrl = new PageInfo(routePath);
    let destRoute: string = '';
    switch (this.indParam.CurrentUrl.Url) {
      case '/docx':
      case 'docx':
        destRoute = 'view/documents/docx/models';
        break;
      case '/dataimportconfig':
      case 'dataimportconfig':
        destRoute = 'view/admin/dataimport';
        break;
      case '/commentaires':
      case 'commentaires':
        destRoute = 'view/documents/comments/models';
        break;
      case '/formaeva':
      case 'formaeva':
        destRoute = 'view/formaeva/export';
        break;
      case '/webinscription':
      case 'webinscription':
        destRoute = 'view/webstore/call';
        break;
      case '/queoval/sendinblue':
      case 'queoval/sendinblue':
        destRoute = 'view/sendinblue/sender';
        break;
      case '/PageCreationBo':
      case 'PageCreationBo':
        destRoute = 'view/admin/bo';
        break;
      case '/PageStatCycle':
      case 'PageStatCycle':
        destRoute = 'view/statistique/liste-cycles';
        break;
      case '/view/facturation/preparation-facturation':
        destRoute = '/view/facturation/preparation-facturation';
        break;
      case '/view/facturation/bo-facturation':
        destRoute = '/view/facturation/bo-facturation';
        break;
      default:
        destRoute = this.indParam.CurrentUrl.Url;
        break;
    }
    this.router.navigate([destRoute]);
  }

  private uniformizeUrl(url: string): string {
    let destRoute: string = '';
    switch (url) {
      case '/docx':
      case 'docx':
        destRoute = 'view/documents/docx/models';
        break;
      case '/dataimportconfig':
      case 'dataimportconfig':
        destRoute = 'view/admin/dataimport';
        break;
      case '/commentaires':
      case 'commentaires':
        destRoute = 'view/documents/comments/models';
        break;
      case '/formaeva':
      case 'formaeva':
        destRoute = 'view/formaeva/export';
        break;
      case '/webinscription':
      case 'webinscription':
        destRoute = 'view/webstore/call';
        break;
      case '/queoval/sendinblue':
      case 'queoval/sendinblue':
        destRoute = 'view/sendinblue/sender';
        break;
      case '/PageCreationBo':
      case 'PageCreationBo':
        destRoute = 'view/admin/bo';
        break;
      case '/PageStatCycle':
      case 'PageStatCycle':
        destRoute = 'view/statistique/liste-cycles';
        break;
      case '/view/facturation/preparation-facturation':
        destRoute = '/view/facturation/preparation-facturation';
        break;
      case '/view/facturation/bo-facturation':
        destRoute = '/view/facturation/bo-facturation';
        break;
      default:
        destRoute = url;
        break;
    }
    return destRoute;
  }

  // permet de supprimer un lien dans le breadcrumb
  //////private deleteLink(index: number = 0): void {
  private deleteLink(index: number): void {
    // récupération du composant enfant
    const originChild: string = this._breadcrumb[this._breadcrumb.length - 1].link;
    this._breadcrumb.splice(index + 1, this._breadcrumb.length - 1 - index);
    const prm = this._breadcrumb[this._breadcrumb.length - 1].data;
    const iChildFrom: number = prm.params.findIndex(e => e.key == 'childFrom')
    if (iChildFrom > -1) {
      prm.params[iChildFrom].value = originChild;
    } else {
      prm.params.push(new BreadDik('childFrom', originChild));
    }
    this.breadcrumb$.next(this._breadcrumb);
  }

  // permet de remttre le breadcumb à 0
  private reload(): void {
    this._breadcrumb = new Array<BreadcrumbModel>();
  }

  private setBreadCrumbData(paramChain: string): QueovalParam {
    let prms: string = paramChain;
    if (prms !== '') {
      if (prms.includes('\'')) {
        prms = prms.replace(/'/g, '').trim();
      }
      return new QueovalParam(new BreadDik('params', prms));
    }
    return new QueovalParam();
  }

  //#endregion Private Function

  public loadContextSegmentation(pCodeBO: string, pIdDonnee: string, pMainShortCut: MainShortcut | null, pIsAngular: boolean): void {

    // Ouverture du bo dans son contexte
    let sd: MainShortcut = new MainShortcut();
    this.codeBO = pCodeBO;
    this.idDonnee = pIdDonnee;

    if (pIsAngular) {
      // Mode Angular
      if (pMainShortCut == null) {
        sd.DisplLAN = '1';
        sd.Page_LAN = 'view/segmentation';
        sd.ParamLAN = `P1=${pCodeBO}&P2=${pIdDonnee}'`;
        sd.ImageLAN = 'QCONTEXT';
      } else {
        sd = pMainShortCut;
      }

      const model: MainModel = new MainModel();
      model.PostMode = 'SHORTCUTSDETAILS';
      model.SelectedRaccourci = sd;
      this.data.postHttp<MainModel>(`${this.indParam.AppParams.apiUrl}api/main/`, model).subscribe((result: MainModel) => {
        if (!result.HasError) {
          this.raccourciData = result.SelectedRaccourciData;
          this.changeShortcut(sd.Page_LAN, result.SelectedRaccourciData.SidebarTitle, true, this.setBreadCrumbData(sd.ParamLAN));
        }
      });

    } else {
      // Mode Aspx
      if (pMainShortCut == null) {
        sd.DisplLAN = '1';
        sd.Page_LAN = `${this.indParam.AppParams.appUrl}pagedonnee.aspx`
        sd.ParamLAN = `P1=${pCodeBO}&P2=${pIdDonnee}`;
        sd.ImageLAN = 'QCONTEXT';
      } else {
        sd = pMainShortCut;
      }
      const model: MainModel = new MainModel();
      model.PostMode = 'SHORTCUTSDETAILS';
      model.SelectedRaccourci = sd;
      this.data.postHttp<MainModel>(`${this.indParam.AppParams.apiUrl}api/main/`, model).subscribe((result: MainModel) => {
        if (!result.HasError) {
          // being added to NgZone for exposing the function to external javascript
          // we need to trigger change detection manually in Angular
          this.zone.run(() => {
            this.raccourciData = result.SelectedRaccourciData;
            //////////// On remet le fil d'ariane à 0
            const queovalParams: QueovalParam = this.setBreadCrumbData(sd.ParamLAN);
            queovalParams.params.push(new BreadDik('shortcut', sd.Name_LAN));
            this.changeShortcut(sd.Page_LAN, result.SelectedRaccourciData.SidebarTitle, true, queovalParams);

            localStorage.setItem('frameref', result.SelectedRaccourciData.MainPageURL);
            //this.indParam.stockData('frameref', result.SelectedRaccourciData.MainPageURL);
            this.indParam.CurrentUrl = new PageInfo('/view/iframe');
            this.router.navigate(['/view/iframe']);
          });
        }
      });
    }
  }

  public setDataCurrentRoute(data: QueovalParam) {
    this._breadcrumb[this._breadcrumb.length-1].data = data;
  }
}
